import { Injectable } from '@angular/core';
import {
  Story,
  createStoryObject,
} from '@jaimo-solutions-gmbh/platform-services-module';
import { getImagePath } from '../utils/getImagePath';
import { getTodaysStories } from '../api/stories';

@Injectable({
  providedIn: 'root',
})
export class StoriesService {
  private storedStories: any[] = [];

  isRequestingStories = false;

  constructor() {}

  private preload(url, type) {
    return new Promise<HTMLImageElement | HTMLVideoElement>(
      (resolve, reject) => {
        if (type === 2) {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = (e) => reject(e);
          img.src = url;
        } else {
          const video = document.createElement('video');
          video.style.height = '100%';
          video.playsInline = true;
          video.oncanplaythrough = () => resolve(video);
          video.onerror = () => reject(url);
          video.src = url;
          video.load();
        }
      }
    );
  }

  async hasStories(handle) {
    return new Promise<boolean>((resolve, reject) => {
      if (this.isRequestingStories) {
        const wait = setInterval(() => {
          if (!this.isRequestingStories) {
            window.clearInterval(wait);
            resolve(
              this.storedStories.some((stored) => stored.account === handle)
            );
          }
        }, 1000);
      } else {
        resolve(this.storedStories.some((stored) => stored.account === handle));
      }
    });
  }

  async loadStories(handle: string) {
    this.isRequestingStories = true;
    getTodaysStories(handle).then(({ data }) => {
      const stories: Story[] = data.map(createStoryObject);
      stories.sort((a, b) => {
        return a.createdAt - b.createdAt;
      });
      if (stories.length > 0) {
        Promise.all(
          stories.map((story) =>
            this.preload(
              getImagePath() + story.attachment.filename,
              story.attachment.mimeType
            )
          )
        )
          .then((preloaded: (HTMLImageElement | HTMLVideoElement)[]) => {
            const storedStory = {
              account: stories[0].source.accountSource.handle,
              stories: stories.map((story, index) => ({
                ...story,
                file: preloaded[index],
                duration:
                  preloaded[index] instanceof HTMLVideoElement
                    ? (preloaded[index] as HTMLVideoElement).duration
                    : undefined,
              })),
            };
            this.storedStories.push(storedStory);
            this.isRequestingStories = false;
          })
          .catch((url) => {
            console.error('Failed to preload', url);
            this.isRequestingStories = false;
          });
      }
    });
  }

  async getStories(handle) {
    return new Promise((resolve, reject) => {
      if (this.isRequestingStories) {
        const wait = setInterval(() => {
          if (!this.isRequestingStories) {
            window.clearInterval(wait);
            resolve(
              this.storedStories.find((stored) => stored.account === handle)
            );
          }
        }, 100);
      } else {
        resolve(this.storedStories.find((stored) => stored.account === handle));
      }
    });
  }
}
